var _defs, _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCadastro10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 864 783.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:url(#Gradiente_sem_nome_7);}.cls-3{fill:url(#Gradiente_sem_nome_7-2);}.cls-4{fill:url(#Gradiente_sem_nome_7-3);}.cls-5{fill:url(#Gradiente_sem_nome_7-4);}.cls-6{fill:url(#Gradiente_sem_nome_7-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7",
    x1: 694.88,
    y1: -13820.77,
    x2: 736.61,
    y2: -13809.94,
    gradientTransform: "matrix(1, 0, 0, -1, -267.64, -13118.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c92795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#ac2aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#872eca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-2",
    x1: 784.03,
    y1: -13794.41,
    x2: 824.08,
    y2: -13781,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-3",
    x1: 605.9,
    y1: -13794.41,
    x2: 645.95,
    y2: -13781,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-4",
    x1: 695.08,
    y1: -13443.5,
    x2: 734.91,
    y2: -13404.72,
    xlinkHref: "#Gradiente_sem_nome_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7-5",
    x1: 729.18,
    y1: -13533.22,
    x2: 1054.24,
    y2: -13204.87,
    xlinkHref: "#Gradiente_sem_nome_7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1097.03,
    y: -847.41,
    width: 1605.6,
    height: 1716.33,
    transform: "translate(763.22 1533.11) rotate(-53.58)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M432.12,778.48c-12.08,0-21.6-9.38-21.6-20.77V643.37c0-11.61,9.75-20.76,21.6-20.76,12.07,0,21.6,9.38,21.6,20.76V757.71C453.72,769.1,444,778.48,432.12,778.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M521.06,734.27c-12.07,0-21.59-9.38-21.59-20.77V634.22c0-11.61,9.75-20.76,21.59-20.76,12.08,0,21.6,9.38,21.6,20.76V713.5C542.89,724.89,533.14,734.27,521.06,734.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M342.93,734.27c-12.07,0-21.59-9.38-21.59-20.77V634.22c0-11.61,9.75-20.76,21.59-20.76,12.08,0,21.6,9.38,21.6,20.76V713.5C364.76,724.89,355,734.27,342.93,734.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M432.12,283.85c-20.91,0-37.63,16.3-37.63,36.17s17,36.18,37.63,36.18,37.62-16.3,37.62-36.18S452.79,283.85,432.12,283.85Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M749.82,569.46c-17.65-70.79-60.38-135.77-118.44-179.76.23-6,.47-12.06.47-18.09,0-159.44-76.65-302.36-190.44-355.51a21.42,21.42,0,0,0-18.81,0C310,68.58,232.39,212.39,229.37,374.51c0,6.92,0,13.85.46,20.55-58.06,47.56-98.93,109.87-115.65,177.08A19.84,19.84,0,0,0,118.13,590a22.4,22.4,0,0,0,17,7.81h68.28c28.56,0,54.81-12.28,72-34.16,1.39-1.57,2.09-3.58,3.25-5.36,27.64,27.24,85.94,46,153.29,46,66.88,0,124.71-18.31,152.81-45.11a5.63,5.63,0,0,1,.93,1.57c17.18,21.88,43.43,34.38,72,34.38h71.29a21.85,21.85,0,0,0,17-8A19.5,19.5,0,0,0,749.82,569.46ZM240.75,538.65a47.35,47.35,0,0,1-37.39,17.64H164.11c14.4-40,38.78-77.27,71.06-109A434.89,434.89,0,0,0,248,502.91,40,40,0,0,1,240.75,538.65ZM432.11,398.18c-44.59,0-81.05-35.06-81.05-77.93s36.46-77.94,81.05-77.94,81.06,34.84,81.06,77.94S476.71,398.18,432.11,398.18ZM657.63,553.39a47.33,47.33,0,0,1-37.4-17.65c-8.13-10.49-10.68-23.44-7.2-35.28a413.58,413.58,0,0,0,13.7-59.4,290.35,290.35,0,0,1,73.39,112.33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCadastro10);
export default __webpack_public_path__ + "static/media/icon_cadastro-10.1b5a452ef919a130873ab7a225ad3e94.svg";
export { ForwardRef as ReactComponent };